// Shared helpers for the internal-page design system (buttons/labels/avatars/rating rings).
// See client/src/styles/shared-components.css for the class definitions these produce.

const AVATAR_CLASSES = ['mtn-av-1', 'mtn-av-2', 'mtn-av-3', 'mtn-av-4', 'mtn-av-5', 'mtn-av-6', 'mtn-av-7'];

export function avatarClass(name) {
  const str = name || '?';
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return AVATAR_CLASSES[h % AVATAR_CLASSES.length];
}

export function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || parts[0]?.[1] || '')).toUpperCase();
}

// Tier classification for the six status-style columns on Recruiter Portal / Candidate Archive
// (screening_status, fadv_status, bg_status, drug_status, physical_status, gcic_status) --
// mirrors the exact value->color mapping the old .status-badge.<value> CSS already encoded
// (RecruiterPortal.css), generalized into a keyword match instead of relying on the old
// className-string-splits-on-spaces trick (`status-badge not responding` accidentally matching
// `.status-badge.not` via the space-separated class list -- real, but fragile, not worth
// reproducing deliberately in a new component).
// Order matters: checked top-to-bottom, first match wins. "fail" must come before "pass"
// because "ineligible" (a fail keyword) contains "eligible" (a pass keyword) as a substring --
// checking pass first would silently misclassify every Ineligible status as a pass (green,
// checkmark) instead of fail (red, X). Found live on the FADV status column.
const TIER_KEYWORDS = {
  // "not responding" / "not interested" are screening_status-only values (the other five status
  // fields this classifier serves don't use them) -- treated as fail (red, X) rather than the
  // old neutral/grey styling, per explicit request.
  fail: ['fail', 'ineligible', 'positive', 'not responding', 'not interested'],
  pass: ['pass', 'complete', 'eligible'],
  warn: ['pending'],
  info: ['uploaded'],
};

export function classifyStatusTier(value) {
  const v = (value || '').toLowerCase();
  if (!v || v === '-') return 'neutral';
  for (const [tier, keywords] of Object.entries(TIER_KEYWORDS)) {
    if (keywords.some(k => v.includes(k))) return tier;
  }
  return 'neutral';
}

export const TIER_ICON = { pass: '✓', warn: '●', fail: '✕', info: '', neutral: '' };
export const TIER_CLASS = { pass: 'mtn-label-pass', warn: 'mtn-label-warn', fail: 'mtn-label-fail', info: 'mtn-label-info', neutral: 'mtn-label-neutral' };

export function ringTier(rating) {
  if (rating === null || rating === undefined) return null;
  if (rating >= 8) return 'mtn-ring-high';
  if (rating >= 5) return 'mtn-ring-mid';
  return 'mtn-ring-low';
}

export const RING_GRADIENT_STOPS = {
  'mtn-ring-high': ['#6ee7b7', '#059669'],
  'mtn-ring-mid': ['#fcd34d', '#d97706'],
  'mtn-ring-low': ['#fca5a5', '#dc2626'],
};
